import { getDynamicConfigs } from '@hungryroot/rest';

export async function fetchFeatureFlagDefinitions<T extends readonly string[]>(
  names: T
) {
  return await getDynamicConfigs({
    name: names,
    limit: 1000,
  });
}
